import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EError } from '../../shared/enums/error-type.enum';

@Component({
    selector: 'app-error-message',
    template: `
    <span data-test="errorMessage">{{getErrors()}}</span>
  `,
    standalone: false
})
export class ErrorMessageComponent {
    @Input() formController: UntypedFormControl;

    constructor(private translate: TranslateService) {
    }

    getErrors() {
        const errors = [
            EError.REQUIRED,
            EError.MAX,
            EError.MIN,
            EError.VALUE_LESSTHAN_EQUALTO_MIN,
            EError.VALUE_LESSTHAN_MIN,
            EError.VALUE_GREATERTHAN_EQUALTO_MAX,
            EError.VALUE_GREATERTHAN_MAX,
            EError.MIN_LENGTH,
            EError.MAX_LENGTH,
            EError.DECIMAL_PRECISION,
            EError.ALPHABET_ONLY,
            EError.NUMBER_ONLY,
            EError.ALPHANUMERIC_SPACE,
            EError.POSTAL_CODE,
            EError.COMPARE_VALIDATION,
        ];

        for (const error of errors) {
            if (this.formController.hasError(error)) {
                return this.getMessage(error);
            }
        }
        return '';
    }
    

    getMessage(errorParam: string) {
        const errors = this.formController.errors;
        let message: string;
        switch (errorParam) {
            case 'required': {
                message = this.translate.instant('MESSAGES.FIELD_IS_REQUIRED');
                break;
            }
            case 'max': {
                message = this.translate.instant('MESSAGES.SHOULD_BE_LESS_THAN_OR_EQUAL_TO', { value: errors.max.max });
                break;
            }
            case 'min': {
                message = this.translate.instant('MESSAGES.SHOULD_BE_GREATER_THAN_OR_EQUAL_TO', { value: errors.min.min });
                break;
            }
            case 'minlength': {
                message = this.translate.instant('MESSAGES.CHARACTER_SHOULD_BE_GREATER_THAN_OR_EQUAL_TO', { value: errors.minlength.requiredLength });
                break;
            }
            case 'maxlength': {
                message = this.translate.instant('MESSAGES.CHARACTER_SHOULD_BE_LESS_THAN_OR_EQUAL_TO', { value: errors.maxlength.requiredLength });
                break;
            }
            case 'valueIsLessThanEqualToMin': {
                message = this.translate.instant('MESSAGES.INPUT_IS_LESS_THAN_EQUAL', { value: errors.valueIsLessThanEqualToMin.valueIsLessThanEqualToMin });
                break;
            }
            case 'valueIsLessThanMin': {
                message = this.translate.instant('MESSAGES.INPUT_IS_LESS_THAN', { value: errors.valueIsLessThanMin.valueIsLessThanMin });
                break;
            }

            case 'valueIsGreaterThanEqualToMax': {
                message = this.translate.instant('MESSAGES.INPUT_IS_GREATER_THAN_EQUAL', { value: errors.valueIsGreaterThanEqualToMax.valueIsGreaterThanEqualToMax });
                break;
            }
            case 'valueIsGreaterThanMax': {
                message = this.translate.instant('MESSAGES.INPUT_IS_GREATER_THAN', { value: errors.valueIsGreaterThanMax.valueIsGreaterThanMax });
                break;
            }

            case 'decimalPrecision': {
                message = this.translate.instant('MESSAGES.DECIMAL_PRECISION_ALLOWED', { value: errors.decimalPrecision.decimalPrecision });
                break;
            }
            case 'alphabetOnly': {
                message = this.translate.instant('MESSAGES.ENTER_ALPHABET_ONLY');
                break;
            }
            case 'numberOnly': {
                message = this.translate.instant('MESSAGES.ENTER_NUMBER_ONLY');
                break;
            }
            case 'alphaNumericSpace': {
                message = this.translate.instant('MESSAGES.SPECIAL_CHARACTERS_NOT_ALLOWED');
                break;
            }
            case 'postalCode': {
                message = this.translate.instant('MESSAGES.ENTER_VALID_POSTAL_CODE');
                break;
            }
            case 'compareValidator': {
                message = this.formController.errors.compareValidator.errorMessage;
                break;
            }
        }
        return message;
    }


}
